import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "components/atoms/BasicTable";
import Button from "components/atoms/Button/Button";
import { Card } from "components/atoms/Card";
import React, { useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { AddOrEdit } from "./components/addOrEdit";
import { ConfirmDelete } from "./components/confirmDelete";
import { Row } from "./components/row";
import { usePageIntent } from "./model/usePageIntent";
import PageIntentSkeleton from "components/atoms/layout/PageIntent/PageIntentSkeleton";

export const PageIntentModule: React.FC = () => {
  const {
    companyPages,
    isLoading,
    form,
    editOrUpdateModal,
    confirmDeleteModal,
    handleFormSubmit,
    handleDeleteItem,
    handleEditItem,
  } = usePageIntent();

  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      const timeout = setTimeout(() => setShowContent(true), 200);
      return () => clearTimeout(timeout);
    } else {
      setShowContent(false);
    }
  }, [isLoading]);

  return (
    <>
      {isLoading && (
        <div className="opacity-100 transition-opacity duration-300">
          <PageIntentSkeleton />;
        </div>
      )}

      {!isLoading && (
        <Card
          className="!p-0 h-fit overflow-hidden"
          headerClassName="p-4"
          title="Page Intent"
          subtitle="Define the level of interest based on page visits"
          icon="page"
          bodyClassName="h-full w-full overflow-scroll"
          buttonComponent={
            <Button
              onClick={() => editOrUpdateModal.openModal()}
              buttonContainerClassName="gap-2"
              isProcessing={isLoading}
              disabled={false}
              iconName="plus"
              isProcessingTitle={"Adding new page url..."}
              size="xs"
              action="submit"
            >
              Add New Page Url
            </Button>
          }
        >
          <FormProvider {...form}>
            {companyPages.length > 0 ? (
              <>
                <Table>
                  <TableHeader>
                    <TableRow className="max-h-[32px]">
                      <TableCell
                        isHeader
                        className="text-left !p-2 !px-4 whitespace-nowrap"
                      >
                        Page URL
                      </TableCell>
                      <TableCell isHeader className="!p-2 w-full">
                        Intent
                      </TableCell>
                      <TableCell isHeader className="!p-2 text-center max-w-4">
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {companyPages.map((page) => (
                      <Row
                        key={page.clientPage.id}
                        {...page}
                        handleEditModal={() => handleEditItem(page)}
                        handleDeleteModal={() =>
                          confirmDeleteModal.openModal(page.clientPage.id)
                        }
                      />
                    ))}
                  </TableBody>
                </Table>
              </>
            ) : (
              <div className="p-4 text-center text-gray-500">
                No pages available. Click "Add New Page Url" to get started.
              </div>
            )}

            {editOrUpdateModal.isOpen && (
              <AddOrEdit
                handleSubmit={handleFormSubmit}
                id={
                  editOrUpdateModal.isOpen !== true
                    ? editOrUpdateModal.isOpen
                    : undefined
                }
                handleClose={editOrUpdateModal.closeModal}
              />
            )}
            {confirmDeleteModal.isOpen && (
              <ConfirmDelete
                onCancel={confirmDeleteModal.closeModal}
                onDelete={handleDeleteItem}
              />
            )}
          </FormProvider>
        </Card>
      )}
    </>
  );
};
